<template>
	<div class="warning-modal-container">
		<BaseIcon
			class="modal-close-button flex-end"
			icon="close"
			:isCustom="true"
			type="standard"
			@click="$modal.hide('warningModal')"
			ariaLabel="close modal dialog" />
		<p class="message">
			{{message}}
		</p>
		<div class="modal-action-wrapper" v-for="(button, index) in buttons" :key="`warn-action-${index}`">
			<BaseButton
				:title="button.title"
				type="modal-button"
				@click="button.action" />
		</div>
	</div>
</template>

<script>
	import navigationMixin from '@Mixin/navigationMixin';
	export default {
		mixins: [navigationMixin],
		props: {
			buttons: {
				type: Array,
				default: () => {
					console.warn('no action buttons were assigned to warning modal');
				},
			},
			message: {
				type: String,
				default: () => {
					console.warn('no message assigned to warning modal');
				},
			},
		},
	};
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	.warning-modal-container {
		display: flex;
		flex-direction: column;
		justify-content: start;
		width: 90%;
		height: 300px;
		.message {
			margin: 1.3em;
			background-color: transparent;
			font-size: 18px;
			font-weight: bold;
			text-align: center;
		}
		.modal-action-wrapper {
			display: flex;
			justify-content: center;
			margin: 7px;
		}
	}
	@include mobile {}
	@include desktop {}
	@include tablet {}
</style>


// WEBPACK FOOTER //
// src/components/checkout/WarningModal.vue